import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Adal from 'vue-adal';
import * as microsoftTeams from '@microsoft/teams-js';

import { store } from './store';
import router from './router';
import { ws } from './wapi/ws';

import App from './App.vue';

import BaseLayout from '@/layouts/base.vue';

import './style/main.scss';
import './style/bootstrap-custom.scss';

import i18n from './i18n';
import vSelect from 'vue-select';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component('v-select', vSelect);
Vue.component('base-layout', BaseLayout);

// For Teams Tab
if (process.env.NODE_ENV === 'development') {
    new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount('#app');
}
else {
    microsoftTeams.initialize(() => {
        new Vue({
            router,
            store,  
            i18n,
            render: (h) => h(App),
        }).$mount('#app');
    });
}
